function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.89 53.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M27.28,29.43a15.74,15.74,0,1,0-15.44,0C5,31.08.25,35.93,0,41.65A1.72,1.72,0,0,0,0,42,11.47,11.47,0,0,0,11.46,53.5h16A11.49,11.49,0,0,0,38.89,42C38.89,36.21,34.09,31.14,27.28,29.43Zm-11,1.7a15.64,15.64,0,0,0,6.58,0v2.33a3.29,3.29,0,1,1-6.58,0ZM7.79,15.74A11.74,11.74,0,1,1,24.25,26.48a1.8,1.8,0,0,0-.38.16A11.72,11.72,0,0,1,7.79,15.74ZM27.43,49.5h-16A7.46,7.46,0,0,1,4,42.36c0-.1,0-.21,0-.32,0-3.8,3.4-7.23,8.21-8.56a7.29,7.29,0,0,0,14.58,0v0c4.77,1.36,8.07,4.76,8.07,8.6A7.47,7.47,0,0,1,27.43,49.5Z",
    style: {
      fill: "currentColor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.13ef8544.svg";
export { ForwardRef as ReactComponent };